(() => {
  if (window.__essenceColorGalleryFilterLoaded) return;
  window.__essenceColorGalleryFilterLoaded = true;

  const gallerySelector = "media-gallery[data-color-gallery-filter]";
  const hiddenClass = "essence-color-gallery-hidden";

  function sectionFor(element) {
    return element.closest("section[id^='shopify-section']") || element.closest(".sec__featured-product");
  }

  function colorFieldset(section) {
    return section && section.querySelector(".product-form__input_color");
  }

  function selectedColor(section) {
    const fieldset = colorFieldset(section);
    if (!fieldset) return "";
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value.trim();
    const select = fieldset.querySelector("select");
    if (select) return select.value.trim();
    const current = fieldset.querySelector(".option_value");
    return current ? current.textContent.trim() : "";
  }

  function imageMatchesColor(slide, color) {
    const image = slide.querySelector("img");
    const alt = (image && image.getAttribute("alt") || "").trim().toLocaleLowerCase();
    const value = color.trim().toLocaleLowerCase();
    if (!alt || !value) return false;
    return alt === value ||
      alt.startsWith(value + " ") ||
      alt.startsWith(value + "-") ||
      alt.endsWith(" - " + value) ||
      alt.includes(" - " + value + " -");
  }

  function filterGallery(gallery, color) {
    if (!color) return;
    const slides = [...gallery.querySelectorAll(".swiper-slide")];
    for (const slide of slides) {
      const matches = imageMatchesColor(slide, color);
      slide.classList.toggle(hiddenClass, !matches);
      slide.hidden = !matches;
      if (matches) {
        slide.style.removeProperty("display");
      } else {
        slide.style.setProperty("display", "none", "important");
      }
    }
    gallery.dataset.colorSelected = "true";

    requestAnimationFrame(() => {
      for (const element of gallery.querySelectorAll(".swiper")) {
        const swiper = element.swiper;
        if (!swiper) continue;
        swiper.update();
        const visibleIndex = [...swiper.slides].findIndex(slide => !slide.classList.contains(hiddenClass));
        if (visibleIndex >= 0) swiper.slideTo(visibleIndex, 0, false);
      }
      const visibleMainSlides = gallery.querySelectorAll(".media-main-swiper .swiper-slide:not(." + hiddenClass + ")");
      gallery.querySelectorAll(".main-slide__navigation, .swiper-pagination").forEach(control => {
        control.hidden = visibleMainSlides.length < 2;
      });
    });
  }

  function applySelection(section, color) {
    if (!section || !color) return;
    section.querySelectorAll(gallerySelector).forEach(gallery => filterGallery(gallery, color));
  }

  function init() {
    document.querySelectorAll("media-gallery").forEach(gallery => {
      const section = sectionFor(gallery);
      if (!colorFieldset(section)) return;
      gallery.setAttribute("data-color-gallery-filter", "");
      gallery.removeAttribute("data-color-selected");
      gallery.querySelectorAll(".swiper-slide").forEach(slide => slide.classList.add(hiddenClass));

      let initialColor = selectedColor(section);
      if (!initialColor) {
        const firstAvailableColor = colorFieldset(section).querySelector('input[type="radio"]:not(:disabled)');
        if (firstAvailableColor) {
          firstAvailableColor.checked = true;
          firstAvailableColor.dispatchEvent(new Event("change", { bubbles: true }));
          initialColor = firstAvailableColor.value.trim();
        }
      }
      if (initialColor) filterGallery(gallery, initialColor);
    });
  }

  document.addEventListener("change", event => {
    if (!event.target.closest(".product-form__input_color")) return;
    const section = sectionFor(event.target);
    applySelection(section, selectedColor(section));
  }, true);

  document.addEventListener("click", event => {
    const choice = event.target.closest(".product-form__input_color label, .product-form__input_color [data-value]");
    if (!choice) return;
    const section = sectionFor(choice);
    setTimeout(() => applySelection(section, selectedColor(section) || choice.dataset.value || ""), 0);
  }, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();